import React from "react";
import { useTranslation } from "react-i18next";
import {
  CopyOutlined,
  DownloadOutlined,
  PlusOutlined,
  MinusOutlined,
} from "us.icons";
import { $Popconfirm, $Divider, $Button } from "us.common/components";
import { TemplateActions } from "components/EditorHome/Constants";
interface IItemMenu {
  record: any;
  actions?: TemplateActions[];
  onCallAction: (actionType: TemplateActions) => void;
}

/**
 * @description - template item actions
 * @link Design Document -
 * @author Ishan Udyoga <ishanud@unicorn-solutions.com>
 * @since 11/09/2022
 */
const ItemMenu: React.FC<IItemMenu> = ({
  record,
  actions= [
    TemplateActions.COPY,
    TemplateActions.DOWNLOAD,
    TemplateActions.ACTIVATE_OR_DEACTIVATE,
  ],
  onCallAction,
}) => {
  const { t } = useTranslation();
  const { isActive, isUsed, isMessageTemplateAdded } = record;

  return (
    <div className="table-more-content" data-testid="popover-content">
      {actions?.includes(TemplateActions.COPY) && (
        <div
          className="d-flex  flex-row more-item"
          data-testid="copy-btn"
          onClick={() => onCallAction(TemplateActions.COPY)}
        >
          <div className="p-1">
            <CopyOutlined />
          </div>
          <div className="p-1">{t("US.COLLECTION.COMMON:COMMON.COPY")}</div>
        </div>
      )}
      {actions?.includes(TemplateActions.DOWNLOAD) && (
        <div
          className="d-flex flex-row more-item"
          data-testid="edit-btn"
          onClick={() => onCallAction(TemplateActions.DOWNLOAD)}
        >
          <div className="p-1">
            <DownloadOutlined />
          </div>
          <div className="p-1">{t("US.COLLECTION.COMMON:COMMON.DOWNLOAD")}</div>
        </div>
      )}
      {actions?.includes(TemplateActions.ADD_TO_MAESSAGE_TEMPLATES) && (
          <div
            className="d-flex flex-row more-item"
            data-testid="edit-btn"
            onClick={() =>
              onCallAction(TemplateActions.ADD_TO_MAESSAGE_TEMPLATES)
            }
          >
            <div className="p-1">
              {isMessageTemplateAdded ? <MinusOutlined /> : <PlusOutlined />}
            </div>
            <div className="p-1">
              {isMessageTemplateAdded
                ? t(
                    "US.USC.TEMPLATEEDITOR:TEMPLATE_EDITOR.REMOVE_FROM_MESSAGE_TEMPLATES"
                  )
                : t(
                    "US.USC.TEMPLATEEDITOR:TEMPLATE_EDITOR.ADD_TO_MESSAGE_TEMPLATES"
                  )}
            </div>
          </div>
        )}
      <$Divider className="my-2" />
      {actions?.includes(TemplateActions.ACTIVATE_OR_DEACTIVATE) && !isUsed && (
        <$Popconfirm
          title={t("US.COMMON:COMMON.SURE_TO_PROCEED_?")}
          data-testid="popUpConfirm-box"
          onConfirm={() => onCallAction(TemplateActions.ACTIVATE_OR_DEACTIVATE)}
        >
          <div className="d-flex flex-column">
            <$Button
              type="primary"
              className="mb-1"
              size="small"
              data-testid="delete-btn"
            >
              {isActive
                ? t("US.COMMON:MANAGE_ROLES.DEACTIVATE")
                : t("US.COMMON:MANAGE_ROLES.ACTIVATE")}
            </$Button>
          </div>
        </$Popconfirm>
      )}
    </div>
  );
};

export default ItemMenu;
